import { Checkbox, StyledMargin } from '@dreryk/react-components';

import { serviceSettingsTranslationKeys } from '../../../translations';
import { AdvancePaymentsSettingsFormController } from '../AdvancePaymentsSettingsForm.types';

const t = serviceSettingsTranslationKeys.advancePayments.form.automaticRefundField;

export type AutomaticRefundFieldValue = boolean;

type AutomaticRefundFieldProps = Pick<AdvancePaymentsSettingsFormController, 'register'>;

export const AutomaticRefundField = (props: AutomaticRefundFieldProps): JSX.Element => {
   return (
      <StyledMargin top={10} bottom={10}>
         <Checkbox
            testId={'automaticRefundEnabled'}
            controller={props.register('automaticRefundEnabled')}
            label={t.label}
         />
      </StyledMargin>
   );
};
